
import customAxios from "config";
import { renterError } from "utils/errorMessage";

export const getInvoice = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/bookings/tentative_booking_invoice/",
      payload
    );
    return response.data;
  } catch (error) {
    return { error: renterError(error, "invoice") };
  }
};

// Per-cycle price projection for multi-week / multi-month LTR bookings
// (1NOW-1095). Same payload shape as `getInvoice`, but returns an array of
// projected invoices — one per cycle — so the storefront can show each
// upcoming week's total BEFORE the customer confirms the booking. Returns
// an empty array when the company / payload isn't a multi-cycle LTR.
export const getLongTermWeeklyQuote = async (
  payload: any
): Promise<{ data?: any[]; error?: string }> => {
  try {
    const response = await customAxios.post<any>(
      "/api/bookings/long-term-weekly-quote/",
      payload
    );
    return { data: Array.isArray(response.data) ? response.data : [] };
  } catch (error) {
    return { error: renterError(error, "invoice") };
  }
};
